import { useEffect } from 'react';
import { NavLink } from 'react-router';

import { useLanguage } from '../../contexts/language';
import { useNavigation } from '../../hooks/navigation';

import { MenuProfile } from '../menu-profile';

import styles from './style.module.css';

// The phone menu, rendered only while open: the sections as large links under
// the bar, then who is signed in and Profile & settings, where Sign out is.
// Escape closes it, as a menu is expected to; following a link closes it too,
// because the top bar closes it on every route change.
export function Menu({ onClose }) {
  const { text } = useLanguage();
  const { sections } = useNavigation();

  useEffect(function() {
    const onKeyDown = function({ key }) {
      if (key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', onKeyDown);

    return function() {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [ onClose ]);

  const links = sections.map(function({ path, label }) {
    return <NavLink key={ path } className={ styles.link } to={ path }>{ text[ label ] }</NavLink>;
  });

  return (
    <div id='main-menu' className={ styles.menu }>
      <nav className={ styles.links } aria-label={ text.mainNavigation }>{ links }</nav>

      <div className={ styles.footer }>
        <MenuProfile/>

        <NavLink className={ styles.secondary } to='/settings'>{ text.profileAndSettings }</NavLink>
      </div>
    </div>
  );
}
